import { Modal as AntdModal } from 'antd';
import styled from 'styled-components';

const Modal = styled(AntdModal)`
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
  }
`;

export default Modal;
